import React, {useCallback} from 'react';
import {TextField} from '@mui/material';
import {removeInitialSpecialChars} from '../../../../util/sanitizeUtil';
import {CheckInFieldProps} from '../interfaces';
import {CODE_INPUT_PROPS} from './keyboardInputProps';

/**
 * Truck License Plate Number text field.
 * Uppercases and sanitizes input on every keystroke.
 */
const TruckLicensePlateField: React.FC<CheckInFieldProps> = ({value, onValueChange, error, required}) => {
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = removeInitialSpecialChars(e.target.value.toUpperCase());
    onValueChange('truckLicensePlateNumber', sanitized);
  }, [onValueChange]);

  return (
    <TextField
      id="truckLicensePlateNumber"
      name="truckLicensePlateNumber"
      label="Truck License Plate Number"
      value={value}
      onChange={handleChange}
      placeholder="Enter the truck's license plate number"
      variant="standard"
      fullWidth
      required={required}
      error={!!error}
      helperText={error}
      inputProps={{...CODE_INPUT_PROPS, 'aria-label': 'Truck License Plate Number'}}
    />
  );
};

export default TruckLicensePlateField;

